module.exports = __webpack_public_path__ + "img/cardholder.a3676d3d.svg";